import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

type Entity = models.TarifaPPDescuento;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        Cantidad: validation.required,
        Descuento: validation.required

    };
    return validation.getErrors(rules, x);
}


/**
* Modal de edición para un MatrizTarifaPeso
*/
export class TarifaPPDescuentoEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, validar);
    hasError = createSelectorRx(this.errors, err => validation.hasError(err));
    getField = formfields(() => this.props, () => this.errors(this.props));

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const hasError = this.hasError(this.props);

        const Number = getField(kea.Number);
        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Editar peso"
            >

                {kea.autogrid(4, [
                    <Number field="Cantidad" label="Cantidad de guias mayor o igual a" />,
                    <Number field="Descuento" label="Descuento" format="percentage" />
                ])}
            </kea.Modal>
        )
    }
}   



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifapp/descuentos/edit.tsx